module.exports = __webpack_public_path__ + "img/face-happy.37387f73.svg";